<div
    class="cmps-cdk-bg-color-unknown-110 cmps-cdk-border-t-width-0px cmps-cdk-border-r-width-0px cmps-cdk-border-b-width-0p cmps-cdk-border-l-width-4px cmps-cdk-border-solid cmps-cdk-border-l-color-unknown-111 cmps-cdk-border-radius-8px cmps-cdk-d-flex cmps-cdk-align-items-flex-start cmps-cdk-p-0dot5 cmps-cdk-cg-0dot5"
>
    <div
        class="cmps-cdk-bg-color-unknown-113 cmps-cdk-border-radius-12px cmps-cdk-color-white cmps-cdk-font-bold cmps-cdk-px-0dot5 cmps-cdk-text-uppercase cmps-cdk-white-space-nowrap"
    >
        In Brief
    </div>
    <div class="cmps-cdk-color-unknown-112">"{{ area?.phrase }}"</div>
    <div class="cmps-cdk-flex-grow-1"></div>
    <div>
        <button
            type="button"
            class="cmps-cdk-p-0 cmps-cdk-w-20px cmps-cdk-h-20px cmps-cdk-border-radius-4px cmps-cdk-bg-color-transparent cmps-cdk-color-unknown-115 cmps-cdk-cursor-pointer hover:cmps-cdk-color-unknown-120 cmps-cdk-border-width-0p focus:not:focus-visible:cmps-cdk-outline-0"
            [cmpsTooltipTrigger]="'Remove'"
            (click)="_onDeleteClick()"
        >
            <cmps-icon
                class="cmps-cdk-w-18px nested:cmps-cdk-w-inherit"
                svgIcon="close"
            ></cmps-icon>
        </button>
    </div>
</div>
